import { classNames, useGlobalId, useUpdateRef } from '@zambezi/sdk/common'
import PropTypes from 'prop-types'
import React, { forwardRef, useRef } from 'react'
import { useMenu } from './menu'

/**
 * Create a React Nav Menu Group component
 *
 * @param {import('./interfaces').NavMenuGroupProps} props
 * @param {import('react').Ref} ref
 * @returns {JSX.Element}
 */
function navMenuGroup ({ label, className, ...rest }, ref) {
  /** @type {import('react').RefObject<HTMLElement>} */
  const elementRef = useRef()
  const labelId = useGlobalId('zb-nav-menu-group-label-')
  const { content } = useMenu(
    {
      ...rest,
      className: 'zb-nav-menu-group-list',
      orientation: 'vertical'
    },
    elementRef
  )

  useUpdateRef(ref, elementRef)

  return (
    <li
      className={classNames('zb-nav-menu-group', className)}
      ref={elementRef}
      role='group'
      aria-labelledby={label ? labelId : null}
    >
      {!!label && (
        <span className='zb-nav-menu-group-label' id={labelId}>
          {label}
        </span>
      )}
      {content}
    </li>
  )
}

const NavMenuGroup = forwardRef(navMenuGroup)

NavMenuGroup.displayName = 'NavMenuGroup'

NavMenuGroup.propTypes = {
  label: PropTypes.string,
  openItem: PropTypes.number,
  className: PropTypes.string,
  onKeyDown: PropTypes.func,
  onItemSelect: PropTypes.func,
  onItemOpen: PropTypes.func,
  onItemClose: PropTypes.func,
  withAutoOpen: PropTypes.bool
}

NavMenuGroup.defaultProps = {}
NavMenuGroup.componentName = 'zb.NavMenuGroup'

export default NavMenuGroup
